import { createFileRoute } from '@tanstack/react-router'
import FormTemplateDetails from '../components/form-template-details/FormTemplateDetails'

export const Route = createFileRoute('/_a/templates/$templateId/')({
  component: FormTemplateDetails,
})
